import React, { ReactNode } from 'react';
import { SalvButton, SalvFieldHeader, SalvIconButton, SalvModal, SalvTextField, Size } from '@salvapp/ui-components';
import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import { ApiClientDetails } from '../../apis';

type CredentialFieldProps = {
  label: string;
  value: string;
  onCopy: () => void;
};

const CredentialField = ({ label, value, onCopy }: CredentialFieldProps) => (
  <div className='m-b-16'>
    <SalvFieldHeader label={label} size={Size.MEDIUM} />
    <div className='flex-gap-8' style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ flex: 1 }}>
        <SalvTextField ariaLabel={label} value={value} disabled size={Size.MEDIUM} />
      </div>
      <SalvIconButton
        icon={faCopy}
        ariaLabel={`Copy ${label.toLowerCase()}`}
        variant='secondary'
        size={Size.MEDIUM}
        onClick={onCopy}
      />
    </div>
  </div>
);

type ApiClientCreatedModalProps = {
  client: ApiClientDetails;
  onHide: () => void;
  onCopy: (label: string, value: string) => void;
  children?: ReactNode;
};

const ApiClientCreatedModal = ({ client, onHide, onCopy, children }: ApiClientCreatedModalProps) => (
  <SalvModal show onHide={onHide}>
    <SalvModal.Header>API client credentials created</SalvModal.Header>
    <SalvModal.Body>
      <div className='text-s m-b-16'>
        Copy the secret now. It is shown only once and cannot be retrieved afterwards.
      </div>

      <CredentialField label='Client id' value={client.clientId} onCopy={() => onCopy('Client id', client.clientId)} />

      {client.clientSecret && (
        <CredentialField
          label='Client secret'
          value={client.clientSecret}
          onCopy={() => onCopy('Client secret', client.clientSecret!)}
        />
      )}

      {children}
    </SalvModal.Body>
    <SalvModal.Footer>
      <SalvButton label='Done' variant='primary' size={Size.MEDIUM} onClick={onHide} />
    </SalvModal.Footer>
  </SalvModal>
);

export default ApiClientCreatedModal;
